export enum FooterLocalizationId {
    PrivacyPolicyLabel = "footer-labels-links.label_privacy_policy",
    TermsAndConditionsLabel = "footer-labels-links.label_terms_and_conditions",
}
